import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Layout from './Layout';

export default withRouter(
  connect(undefined, undefined)(Layout),
);
